<mat-card>

  <mat-card-header>
    <mat-card-title>Gestión de {{'Contrato' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <!-- DATOS CONTRATO -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos del Contrato
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container *ngIf="canEdit">

          <form [formGroup]="formGroup">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código*</mat-label>
                  <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                    {{ getErrorCodigo() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Tipo*</mat-label>
                  <mat-select formControlName="TipoContrato">
                    <mat-option *ngFor="let s of tipoContratoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['TipoContrato'].valid && formGroup.controls['TipoContrato'].touched">
                    {{ getErrorTipoContrato() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                  <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadId">
                    <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['ComunidadId'].valid && formGroup.controls['ComunidadId'].touched">
                    {{ getErrorComunidad() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Inicio*</mat-label>
                  <input matInput [matDatepicker]="fechaInicioPicker" formControlName="FechaInicio"
                    (click)="fechaInicioPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaInicio')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaInicioPicker></mat-datepicker>
                  <mat-error *ngIf="!formGroup.controls['FechaInicio'].valid && formGroup.controls['FechaInicio'].touched">
                    {{ getErrorFechaInicio() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Fin</mat-label>
                  <input matInput [matDatepicker]="fechaFinPicker" formControlName="FechaFin"
                    (click)="fechaFinPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaFinPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaFin')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaFinPicker></mat-datepicker>
                  <mat-error *ngIf="!formGroup.controls['FechaFin'].valid && formGroup.controls['FechaFin'].touched">
                    {{ getErrorFechaFin() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda*</mat-label>
                  <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select class="text-style" formControlName="MonedaId">
                    <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['MonedaId'].valid && formGroup.controls['MonedaId'].touched">
                    {{ getErrorMonedaId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Importe*</mat-label>
                  <input matInput type="number" formControlName="MontoBase" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['MontoBase'].valid && formGroup.controls['MontoBase'].touched">
                    {{ getErrorMontoBase() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isAlicuotaIvaSearching">IVA{{tenantFeatureFlags?.HabilitarControlCaja ? "*" : ""}}</mat-label>
                  <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect()">
                    <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                    {{ getErrorAlicuotaIvaId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>IVA</b>: {{montoIva | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Importe Total</b>: {{montoTotal | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Observaciones</mat-label>
                  <textarea matInput formControlName="Observaciones" (keyup.enter)="onGuardar()" maxlength="300"></textarea>
                </mat-form-field>
              </div>

            </div>

          </form>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
            </div>
          </div>

        </ng-container>

        <div fxLayout="row stretch" class="zb-readonly" *ngIf="!canEdit">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Tipo</b>: {{item.TipoNombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Fecha Inicio</b>: {{item.FechaInicio | date:'dd/MM/yyyy'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Fecha Fin</b>: {{item.FechaFin | date:'dd/MM/yyyy'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>{{'Comunidad' | translate}}</b>: {{item.Comunidad}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Moneda</b>: {{item.Moneda}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Importe Base</b>: {{item.MontoBase | number:'1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>IVA</b>: {{item.AlicuotaIva}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Monto IVA</b>: {{montoIva | number:'1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-style"><b>Importe Total</b>: {{montoTotal | number:'1.2-2'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Observaciones</b>: {{item.Observaciones}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-expansion-panel>

      <br/>

      <!-- ADJUNTOS -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
            <mat-nav-list>
              <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto" *ngIf="canEdit">
                  <i class="fa fa-trash fa-1x"></i>
                </button>
              </mat-list-item>
            </mat-nav-list>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="canEdit">
            <button mat-icon-button matSuffix (click)="fileInput.click()" [disabled]="isFileAttaching"><mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto</button>
            <input hidden (change)="onNewFileAttach($event)" #fileInput type="file" multiple>
            <mat-label *ngIf="isFileAttaching"><br/><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
          </div>

        </div>

      </mat-expansion-panel>

      <br/>

      <!-- UFs -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-right: 5px;">home</mat-icon> {{'UnidadFuncional' | translate}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="canEdit">

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <mat-label>
                  ¿Qué {{('UnidadFuncional' | translate).toLowerCase()}} formará parte de este {{('Contrato' | translate).toLowerCase()}}?
                </mat-label>
              </div>
              <br/>
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <button mat-raised-button (click)="onUfSearchClick()" [disabled]="isProcessing()" color="primary" class="zb-button" style="margin-right: 10px;">
                  Buscar {{'UnidadFuncional' | translate}} Existente
                </button>
                <button mat-raised-button (click)="onUfNewClick()" [disabled]="isProcessing()" color="accent" class="zb-button" *ngIf="canUfAlta">
                  Nueva {{'UnidadFuncional' | translate}}
                </button>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <ejs-grid #gridUf [dataSource]='item.UnidadesFuncionales' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='UnidadFuncionalCodigo' headerText='Código' width=90></e-column>
              <e-column field='UnidadFuncionalNumero' headerText='Número' width=50></e-column>
              <e-column field='UnidadFuncionalTipoUnidad' headerText='Tipo Unidad' width=110></e-column>
              <e-column field='UnidadFuncionalCantidadAmbientes' headerText='Ambientes' width=50></e-column>
              <e-column field='UnidadFuncionalNroPiso' headerText='Piso' width=50></e-column>
              <e-column field='UnidadFuncionalComunidad' headerText='Comunidad' width=120>
                <ng-template #headerTemplate let-data>
                  {{'Comunidad' | translate}}
                </ng-template>
              </e-column>
              <e-column field='UnidadFuncionalConsorcio' headerText='Consorcio' width=120 *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio"></e-column>
              <e-column field='Importe' headerText='Importe' width=70></e-column>
              <e-column headerText='Acciones' width=50></e-column>
            </e-columns>
            <ng-template #rowTemplate let-data>
              <tr class="e-row">
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCodigo}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNumero}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalTipoUnidad}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCantidadAmbientes}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNroPiso}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalComunidad}}</td>
                <td class="e-rowcell" style="text-align: center;" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">{{data.UnidadFuncionalConsorcio}}</td>
                <td class="e-rowcell" style="text-align: right; padding: 3px 0px;">
                  <ng-container *ngIf="canEdit">
                    <input matInput type="number" [(ngModel)]="data.Importe" name="Importe" (change)="onUfGridFieldChange(data.UnidadFuncionalId, $event)"
                      style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                  </ng-container>
                  <ng-container *ngIf="!canEdit">
                    {{data.Importe | number:'1.2-2'}}
                  </ng-container>
                </td>
                <td class="e-rowcell" style="text-align: center;">
                  <a style="cursor: pointer; margin-right: 5px" (click)="viewUf(data)" *ngIf="canUfAny"><i class="fa fa-eye fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="editUf(data)" *ngIf="canEdit && canUfEdicion"><i class="fa fa-pencil fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="deleteUf(data)" *ngIf="canEdit"><i class="fa fa-trash fa-1x"></i></a>
                </td>
              </tr>
            </ng-template>
            <e-aggregates>
              <e-aggregate>
                <e-columns>
                  <e-column field="Importe" type="Custom" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                        {{sumUfImporte() | number:'1.2-2'}}
                      </mat-label>
                    </ng-template>
                  </e-column>
                </e-columns>
              </e-aggregate>
            </e-aggregates>
          </ejs-grid>
        </div>

      </mat-expansion-panel>

      <br/>

      <!-- Personas -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-right: 5px;">supervisor_account</mat-icon> Beneficiario
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="canEdit">

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <mat-label>
                  ¿Qué {{('Persona' | translate).toLowerCase()}} formará parte de este {{('Contrato' | translate).toLowerCase()}}?
                </mat-label>
              </div>
              <br/>
              <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                <button mat-raised-button (click)="onPersonaSearchClick()" [disabled]="isProcessing()" color="primary" class="zb-button" style="margin-right: 10px;">
                  Buscar {{'Persona' | translate}} Existente
                </button>
                <button mat-raised-button (click)="onPersonaNewClick()" [disabled]="isProcessing()" color="accent" class="zb-button" *ngIf="canPersonaAlta">
                  Nueva {{'Persona' | translate}}
                </button>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <ejs-grid #gridPersona [dataSource]='item.Personas' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='PersonaNombre' headerText='Nombre' width=90></e-column>
              <e-column field='PersonaNroDocumento' headerText='Documento' width=90></e-column>
              <e-column field='PersonaCuit' headerText='CUIT/CUIL' width=90></e-column>
              <e-column field='PersonaMailContacto' headerText='Email' width=90></e-column>
              <e-column field='PersonaMovilContacto' headerText='Nro. Cel.' width=90></e-column>
              <e-column field='Porcentaje' headerText='Porcentaje' width=60 textAlign="right"></e-column>
              <e-column headerText='Acciones' width=70></e-column>
            </e-columns>
            <ng-template #rowTemplate let-data>
              <tr class="e-row">
                <td class="e-rowcell" style="text-align: center;">{{data.PersonaNombre}} {{data.PersonaApellido}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.PersonaTipoDocumento}} {{data.PersonaNroDocumento}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.PersonaCuit}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.PersonaMailContacto}}</td>
                <td class="e-rowcell" style="text-align: center;">{{data.PersonaMovilContacto}}</td>
                <td class="e-rowcell" style="text-align: right; padding: 3px 0px;">
                  <ng-container *ngIf="canEdit">
                    <input matInput type="number" [(ngModel)]="data.Porcentaje" name="Porcentaje" (change)="onPersonaGridFieldChange(data.PersonaId, $event)"
                      style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                  </ng-container>
                  <ng-container *ngIf="!canEdit">
                    {{data.Porcentaje | number:'1.2-2'}}%
                  </ng-container>
                </td>
                <td class="e-rowcell" style="text-align: center;">
                  <a style="cursor: pointer; margin-right: 5px" (click)="viewPersona(data)" *ngIf="canPersonaAny" title="Ver detalles"><i class="fa fa-eye fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="editPersona(data)" *ngIf="canEdit && canPersonaEdicion" title="Editar datos"><i class="fa fa-pencil fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="deletePersona(data)" *ngIf="canEdit" title="Eliminar"><i class="fa fa-trash fa-1x"></i></a>
                  <a style="cursor: pointer; margin-right: 5px;" (click)="sendInvite(data)" *ngIf="data.PuedeEnviarInvitacion" title="Enviar Invitación"><i class="fa fa-envelope"></i></a>
                </td>
              </tr>
            </ng-template>
            <e-aggregates>
              <e-aggregate>
                <e-columns>
                  <e-column field="Porcentaje" type="Custom" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                        {{sumPersonaPorcentaje() | number:'1.2-2'}}%
                      </mat-label>
                    </ng-template>
                  </e-column>
                </e-columns>
              </e-aggregate>
            </e-aggregates>
          </ejs-grid>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="canEdit">
          <button mat-raised-button (click)="calcularPorcentajes()" class="zb-button" [disabled]="isProcessing()">Distribuir Porcentajes Equitativamente</button>
        </div>

      </mat-expansion-panel>

      <!-- Movimientos -->
      <ng-container *ngIf="item != null && item.Id > 0 && canMovimientoView">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Movimientos Asociados
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
            <button mat-raised-button (click)="onCrearMovimientoDeuda()" color="primary" class="zb-button" [disabled]="isDeudaSaving" *ngIf="movimientoList == null || movimientoList.length == 0">
              {{isDeudaSaving ? 'Generando...' : 'Generar Movimiento de Deuda'}}
            </button>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isMovimientosSearching">Buscando...</mat-label>
              <ejs-grid #grid [dataSource]='movimientoList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date'>
                    <ng-template #template let-data>
                      {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                    </ng-template>
                  </e-column>
                  <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date'>
                    <ng-template #template let-data>
                      {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                    </ng-template>
                  </e-column>
                  <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
                  <e-column field='Detalle' headerText='Detalle' width=100></e-column>
                  <!-- <e-column field='MedioPagoNombre' headerText='Medio de Pago' width=90></e-column> -->
                  <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                    <ng-template #template let-data>
                      {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                    </ng-template>
                  </e-column>
                  <!-- <e-column field='AlicuotaIvaNombre' headerText='IVA' width=50></e-column> -->
                  <e-column field='Saldo' headerText='Saldo' textAlign="right" width=70>
                    <ng-template #template let-data>
                      {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=50>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="viewMovimiento(data)"><i class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Incidencias -->
      <ng-container *ngIf="item != null && item.Id > 0 && canViewIncidencias">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">error</mat-icon> Incidencias Asociadas
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isIncidenciasSearching">Buscando...</mat-label>
              <ejs-grid #gridIncidencias [dataSource]='incidenciasList' [allowPaging]="true"
                [allowSorting]="true" *ngIf="!isIncidenciasSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Id' headerText='#' width=60></e-column>
                  <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date" format="dd/MM/yyyy HH:mm" width=60></e-column>
                  <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                  <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                  <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                  <e-column headerText='Acciones' width=40>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 18px" (click)="viewIncidencia(data.Id)">
                        <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <ng-container *ngIf="canEdit">
        <button mat-raised-button (click)="onGuardar()" [disabled]="isProcessing()" color="primary" class="zb-button">
          {{isSaving ? 'Guardando...' : 'Guardar'}}
        </button>
        <button mat-raised-button (click)="openDialogCargaMovimiento(true)" [disabled]="isProcessing()" *ngIf="tenantFeatureFlags?.HabilitarControlCaja && !tieneMovimientoAsociado()"
          class="zb-button">
          {{isSaving ? 'Guardando...' : 'Guardar y Configurar Cuotas'}}
        </button>
      </ng-container>

      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">
        {{canEdit ? 'Cancelar' : 'Cerrar'}}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
